import TransactionsPage from './TransactionsPage';

export default TransactionsPage;
